/**
 * SGKC023A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface InspectionInfo {

    /**
     * 検針年月日
     */
    inspectYmd?: string;
    /**
     * 前回検針年月日
     */
    preInspectYmd?: string;
    /**
     * 検針区分
     */
    kensinDiv?: string;
}

